export var GRID_WRAPPER_FOOTER_CLASS = 'grid-wrapper-footer';
export var GRID_WRAPPER_HEADER_CLASS = 'grid-wrapper-header';
export var GRID_WRAPPER_CONTENT_CLASS = 'grid-wrapper-content';
export var GRID_LAYOUT_TESTID = 'grid-layout';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/components/modules/GridLayout/constants.js
// module id = 881
// module chunks = 11